module.exports = __webpack_public_path__ + "static/media/u_bolt.bbb83756.webp";